// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__30H8I","actionsCol":"EnrolledClinics_actionsCol__3Spe3"};